import { VideoGalleryStyles } from "@azure/communication-react";
import { IStackItemStyles } from "@fluentui/react";

// TODO: `videoGalleryContainerStyles` and `activeElementContainerStyles` are duplicated in the student CallPage and could be merged.
export const videoGalleryContainerStyles: IStackItemStyles = {
    root: {
        height: '100%',
        flex: 2,
    },
};

export const hiddenOverflowVideoGalleryStyles: VideoGalleryStyles = {
    root: {
        '[data-ui-id="responsive-horizontal-gallery"]': { display: 'none' },
    },
    // horizontalGallery: {
    //     nextButton: {
    //         display: 'none'
    //     },
    //     previousButton: {
    //         display: 'none'
    //     },
    //     children: {
    //         display: 'none'
    //     },
    //     root: {
    //         display: 'none'
    //     }
    // }
};
